export const STYLE_OPTIONS = [
    {
        label: "Realistic Image",
        value: "realistic_image"
    },
    {
        label: "Digital Illustration",
        value: "digital_illustration"
    },
    {
        label: "Vector Illustration",
        value: "vector_illustration"
    },
    {
        label: "Icon",
        value: "icon"
    }
];
export const SUBSTYLE_OPTIONS = {
    realistic_image: [
        {
            label: "B&W",
            value: "b_and_w"
        },
        {
            label: "Enterprise",
            value: "enterprise"
        },
        {
            label: "Evening Light",
            value: "evening_light"
        },
        {
            label: "Faded Nostalgia",
            value: "faded_nostalgia"
        },
        {
            label: "Forest Life",
            value: "forest_life"
        },
        {
            label: "Hard Flash",
            value: "hard_flash"
        },
        {
            label: "HDR",
            value: "hdr"
        },
        {
            label: "Motion Blur",
            value: "motion_blur"
        },
        {
            label: "Mystic Naturalism",
            value: "mystic_naturalism"
        },
        {
            label: "Natural Light",
            value: "natural_light"
        },
        {
            label: "Natural Tones",
            value: "natural_tones"
        },
        {
            label: "Organic Calm",
            value: "organic_calm"
        },
        {
            label: "Real Life Glow",
            value: "real_life_glow"
        },
        {
            label: "Retro Realism",
            value: "retro_realism"
        },
        {
            label: "Retro Snapshot",
            value: "retro_snapshot"
        },
        {
            label: "Studio Portrait",
            value: "studio_portrait"
        },
        {
            label: "Urban Drama",
            value: "urban_drama"
        },
        {
            label: "Village Realism",
            value: "village_realism"
        },
        {
            label: "Warm Folk",
            value: "warm_folk"
        }
    ],
    digital_illustration: [
        {
            label: "2D Art Poster",
            value: "2d_art_poster"
        },
        {
            label: "2D Art Poster 2",
            value: "2d_art_poster_2"
        },
        {
            label: "Engraving Color",
            value: "engraving_color"
        },
        {
            label: "Grain",
            value: "grain"
        },
        {
            label: "Hand Drawn",
            value: "hand_drawn"
        },
        {
            label: "Hand Drawn Outline",
            value: "hand_drawn_outline"
        },
        {
            label: "Handmade 3D",
            value: "handmade_3d"
        },
        {
            label: "Infantile Sketch",
            value: "infantile_sketch"
        },
        {
            label: "Pixel Art",
            value: "pixel_art"
        },
        {
            label: "Antiquarian",
            value: "antiquarian"
        },
        {
            label: "Bold Fantasy",
            value: "bold_fantasy"
        },
        {
            label: "Child Book",
            value: "child_book"
        },
        {
            label: "Child Books",
            value: "child_books"
        },
        {
            label: "Cover",
            value: "cover"
        },
        {
            label: "Crosshatch",
            value: "crosshatch"
        },
        {
            label: "Digital Engraving",
            value: "digital_engraving"
        },
        {
            label: "Expressionism",
            value: "expressionism"
        },
        {
            label: "Freehand Details",
            value: "freehand_details"
        },
        {
            label: "Grain 20",
            value: "grain_20"
        },
        {
            label: "Graphic Intensity",
            value: "graphic_intensity"
        },
        {
            label: "Hard Comics",
            value: "hard_comics"
        },
        {
            label: "Long Shadow",
            value: "long_shadow"
        },
        {
            label: "Modern Folk",
            value: "modern_folk"
        },
        {
            label: "Multicolor",
            value: "multicolor"
        },
        {
            label: "Neon Calm",
            value: "neon_calm"
        },
        {
            label: "Noir",
            value: "noir"
        },
        {
            label: "Nostalgic Pastel",
            value: "nostalgic_pastel"
        },
        {
            label: "Outline Details",
            value: "outline_details"
        },
        {
            label: "Pastel Gradient",
            value: "pastel_gradient"
        },
        {
            label: "Pastel Sketch",
            value: "pastel_sketch"
        },
        {
            label: "Pop Art",
            value: "pop_art"
        },
        {
            label: "Pop Renaissance",
            value: "pop_renaissance"
        },
        {
            label: "Street Art",
            value: "street_art"
        },
        {
            label: "Tablet Sketch",
            value: "tablet_sketch"
        },
        {
            label: "Urban Glow",
            value: "urban_glow"
        },
        {
            label: "Urban Sketching",
            value: "urban_sketching"
        },
        {
            label: "Vanilla Dreams",
            value: "vanilla_dreams"
        },
        {
            label: "Young Adult Book",
            value: "young_adult_book"
        },
        {
            label: "Young Adult Book 2",
            value: "young_adult_book_2"
        }
    ],
    vector_illustration: [
        {
            label: "Bold Stroke",
            value: "bold_stroke"
        },
        {
            label: "Chemistry",
            value: "chemistry"
        },
        {
            label: "Colored Stencil",
            value: "colored_stencil"
        },
        {
            label: "Contour Pop Art",
            value: "contour_pop_art"
        },
        {
            label: "Cosmics",
            value: "cosmics"
        },
        {
            label: "Cutout",
            value: "cutout"
        },
        {
            label: "Depressive",
            value: "depressive"
        },
        {
            label: "Editorial",
            value: "editorial"
        },
        {
            label: "Emotional Flat",
            value: "emotional_flat"
        },
        {
            label: "Engraving",
            value: "engraving"
        },
        {
            label: "Infographical",
            value: "infographical"
        },
        {
            label: "Line Art",
            value: "line_art"
        },
        {
            label: "Line Circuit",
            value: "line_circuit"
        },
        {
            label: "Linocut",
            value: "linocut"
        },
        {
            label: "Marker Outline",
            value: "marker_outline"
        },
        {
            label: "Mosaic",
            value: "mosaic"
        },
        {
            label: "Naivector",
            value: "naivector"
        },
        {
            label: "Roundish Flat",
            value: "roundish_flat"
        },
        {
            label: "Segmented Colors",
            value: "segmented_colors"
        },
        {
            label: "Sharp Contrast",
            value: "sharp_contrast"
        },
        {
            label: "Thin",
            value: "thin"
        },
        {
            label: "Vector Photo",
            value: "vector_photo"
        },
        {
            label: "Vivid Shapes",
            value: "vivid_shapes"
        }
    ],
    icon: [
        {
            label: "Broken Line",
            value: "broken_line"
        },
        {
            label: "Colored Outline",
            value: "colored_outline"
        },
        {
            label: "Colored Shapes",
            value: "colored_shapes"
        },
        {
            label: "Colored Shapes Gradient",
            value: "colored_shapes_gradient"
        },
        {
            label: "Doodle Fill",
            value: "doodle_fill"
        },
        {
            label: "Doodle Offset Fill",
            value: "doodle_offset_fill"
        },
        {
            label: "Offset Fill",
            value: "offset_fill"
        },
        {
            label: "Outline",
            value: "outline"
        },
        {
            label: "Outline Gradient",
            value: "outline_gradient"
        },
        {
            label: "Uneven Fill",
            value: "uneven_fill"
        }
    ]
};
